import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';

const OrdersCustomModalSubValueCell = ({ rowData }) => {
	if (['customer', 'address_from', 'address_to'].includes(rowData.id)) {
		return (
			<span className="orders-custom-modal-sub-value-cell__cell">
				<div className="orders-custom-modal-sub-value-cell__cell_bold">{rowData.sub_value.name}</div>
				<div className="orders-custom-modal-sub-value-cell__cell_thin">{rowData.sub_value.code}</div>
			</span>
		);
	}

	return '';
};

OrdersCustomModalSubValueCell.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string.isRequired,
};

export { OrdersCustomModalSubValueCell };
